/* eslint-disable @faire/enforce-internal-folder-encapsulation */
import { BrandInfoProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
import { brandInfoProductTileAdaptor } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoUtils";
import { CaselineProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/CaseSizeText/CaselineProps";
import { debugInfoSectionPropsILeanProductTileAdapter } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/debugInfoSectionPropsILeanProductTileAdapter";
import {
  FavoriteProps,
  productTileFavoritePropsILeanProductTileAdapter,
} from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/FavoriteProps";
import { NotifyMeProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/NotifyMe/NotifyMeProps";
import { notifyMeProductTileAdaptor } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/NotifyMe/NotifyMeUtils";
import { ProductTileImageProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/ProductTileImageProps";
import { ClientFormatMoneyPriceWrapperProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/ClientFormatMoneyPriceWrapperProps";
import { ProductTileOverlayProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/productTileOverlayProps";
import { productTileOverlayProductTileAdaptor } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/productTileOverlayUtils";
import {
  productTileQuickAddPropsILeanProductTileAdapter,
  QuickAddProps,
} from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import {
  QuickViewProps,
  productTileQuickViewPropsILeanProductTileAdapter,
} from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickView/QuickViewProps";
import {
  productTileTopBadgesPropsILeanProductTileAdapter,
  TopBadgesProps,
} from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadgesProps";
import { productTileImageAdapter } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/adapters/ProductTileImageAdapter";
import { productTilePriceAdapter } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/adapters/ProductTilePriceAdapter";
import { productTileTrackingAdapter } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/adapters/ProductTileTrackingAdapter";
import { DebugInfoSectionProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/DebugInfo/DebugInfoSectionProps";
import {
  IProductTileImageConfigProps,
  ITrackingProps,
  ProductTileSwatchesProps,
  ProductTileType,
} from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/types";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

// Could be extended for RSC tiles as well
export interface BaseProductTileProps {
  productToken: string;
  productName: string;
  productTileImageProps: ProductTileImageProps;
  productTileTrackingWrapperProps: ITrackingProps;
  priceTextProps?: ClientFormatMoneyPriceWrapperProps;
  productTileQuickViewProps?: QuickViewProps;
  productTileDebugInfoProps?: DebugInfoSectionProps;
  productTileTopBadgesProps?: TopBadgesProps;
  productTileFavoriteProps?: FavoriteProps;
  productTileQuickAddProps?: QuickAddProps & { showOnHover: boolean };
  productTileSwatchesProps?: ProductTileSwatchesProps;
  productTileOverlayProps?: ProductTileOverlayProps;
  isLoggedInRetailer?: boolean;

  // PRODUCT WITH BRAND
  brandInfoProps?: BrandInfoProps;

  // PRODUCT WITHOUT BRAND
  productTileNotifyMeProps?: NotifyMeProps;
  caseLineProps?: CaselineProps;
  expectedShipDateProps?: string;
}

const getBaseProps = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean,
  productTileImageConfigProps?: IProductTileImageConfigProps
) => {
  const productTileOverlayProps = productTileOverlayProductTileAdaptor(
    productTile,
    true
  );

  const topBadgeProps =
    productTileTopBadgesPropsILeanProductTileAdapter(productTile);

  const priceTextProps = productTilePriceAdapter(productTile, isLoggedIn);

  const quickAddProps =
    productTileQuickAddPropsILeanProductTileAdapter(productTile);
  const favoriteProps = isLoggedIn
    ? productTileFavoritePropsILeanProductTileAdapter(productTile)
    : undefined;
  const productTileDebugInfoProps =
    debugInfoSectionPropsILeanProductTileAdapter(productTile);
  const productTileQuickViewProps =
    productTileQuickViewPropsILeanProductTileAdapter(productTile);

  const productTileImageProps = productTileImageAdapter(
    productTile,
    productTileImageConfigProps
  );

  const productTileTrackingWrapperProps = productTileTrackingAdapter(
    productTile,
    productTileImageConfigProps?.showVerticalImagery ?? false
  );

  return {
    product: productTile.product,
    productTileSwatchesProps: {
      optionDetails: productTile.options_details,
    },
    productName: productTile?.product?.name ?? "",
    productTileOverlayProps,
    productTileQuickViewProps,
    productTileTopBadgesProps: topBadgeProps,
    priceTextProps,
    productTileQuickAddProps: quickAddProps,
    productTileFavoriteProps: favoriteProps,
    productToken: productTile?.product?.token ?? "",
    productTileDebugInfoProps,
    productTileImageProps,
    productTileTrackingWrapperProps,
    isLoggedInRetailer: isLoggedIn,
  };
};

const getProductWithBrandProps = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean,
  brand?: ILeanProductTile.IBrand,
  productTileImageConfigProps?: IProductTileImageConfigProps
) => {
  const brandInfoData = brandInfoProductTileAdaptor({
    productTile,
    brand,
    //TODO(bronwyn): remove references to productSearchString
    productSearchString: "",
    isLoggedInRetailer: isLoggedIn,
    productTileImageConfigProps,
  });

  return {
    brandInfoData,
  };
};

const getProductWithoutBrandProps = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean
) => {
  const notifyMeProps = notifyMeProductTileAdaptor(productTile);

  const caseLineProps: CaselineProps = {
    caseSizeText: productTile.case_size_text,
    availabilityText: productTile.availability_info,
    isLoggedIn: isLoggedIn,
  };

  return {
    productTileNotifyMeProps: isLoggedIn ? notifyMeProps : undefined,
    caseLineProps,
    expectedShipDateProps: productTile?.expected_shipping_date ?? "",
  };
};

const getProductWithBrandTileProps = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean,
  brand?: ILeanProductTile.IBrand,
  productTileImageConfigProps?: IProductTileImageConfigProps
): BaseProductTileProps => {
  const baseProps = getBaseProps(
    productTile,
    isLoggedIn,
    productTileImageConfigProps
  );
  const extendedProps = getProductWithBrandProps(
    productTile,
    isLoggedIn,
    brand,
    productTileImageConfigProps
  );
  return {
    ...baseProps,
    productTileQuickAddProps: isLoggedIn
      ? {
          ...baseProps.productTileQuickAddProps,
          showOnHover: true,
        }
      : undefined,
    brandInfoProps: extendedProps.brandInfoData,
  };
};

const getProductQuickAddOnlyTileProps = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean,
  productTileImageConfigProps?: IProductTileImageConfigProps
): BaseProductTileProps => {
  const quickAddProps =
    productTileQuickAddPropsILeanProductTileAdapter(productTile);
  const productTileImageProps = productTileImageAdapter(
    productTile,
    productTileImageConfigProps
  );

  const productTileTrackingWrapperProps = productTileTrackingAdapter(
    productTile,
    productTileImageConfigProps?.showVerticalImagery ?? false
  );
  return {
    productTileQuickAddProps: isLoggedIn
      ? {
          ...quickAddProps,
          showOnHover: false,
        }
      : undefined,
    productTileImageProps: productTileImageProps,
    productTileTrackingWrapperProps: productTileTrackingWrapperProps,
    productToken: productTile?.product?.token ?? "",
    productName: productTile?.product?.name ?? "",
  };
};

const getProductWithoutBrandTileProps = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean,
  productTileImageConfigProps?: IProductTileImageConfigProps
): BaseProductTileProps => {
  const baseProps = getBaseProps(
    productTile,
    isLoggedIn,
    productTileImageConfigProps
  );
  const extendedProps = getProductWithoutBrandProps(productTile, isLoggedIn);

  return {
    ...baseProps,
    productTileQuickAddProps: isLoggedIn
      ? {
          ...baseProps.productTileQuickAddProps,
          showOnHover: false,
        }
      : undefined,
    ...extendedProps,
  };
};

export const productTileAdapter = (
  productTile: ILeanProductTile,
  isLoggedIn: boolean,
  type: ProductTileType,
  brand?: ILeanProductTile.IBrand,
  productTileImageConfigProps?: IProductTileImageConfigProps
) => {
  if (type === ProductTileType.TILE_WITH_BRAND) {
    return getProductWithBrandTileProps(
      productTile,
      isLoggedIn,
      brand,
      productTileImageConfigProps
    );
  }
  if (type === ProductTileType.TILE_WITHOUT_BRAND) {
    return getProductWithoutBrandTileProps(
      productTile,
      isLoggedIn,
      productTileImageConfigProps
    );
  }
  if (type === ProductTileType.QUICK_ADD_ONLY_TILE) {
    return getProductQuickAddOnlyTileProps(
      productTile,
      isLoggedIn,
      productTileImageConfigProps
    );
  }
  return null;
};
